import { deleteEvent } from '@/app/services/events/events';
import * as Actions from '@/app/store/actions/';
import { Avatar, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const CalendarEventCard = ({ event, handleClose, setRefresh, refresh }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const gotoUpdateEvent = (event) => {
		handleClose();
		navigate(`/calendar-updateevent/${event.id}`);
	};

	const DeleteEvent = (event) => {
		dispatch(Actions.closeDialog());
		deleteEvent(event.id)
			.then((res) => {
				setRefresh(!refresh);
				dispatch(
					Actions.showMessage({
						message: res.data.message,
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				handleClose();
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const isCustomEvent = event?.type === '39';
	return (
		<div className="flex flex-col w-full">
			<div className="flex flex-col w-full items-center -mt-10">
				<Avatar src={event?.event_type?.icon_url} style={{ width: 50, height: 50 }} />
				<div className="justify-self-stretch text-pd-2xl font-semibold">
					{isCustomEvent ? event?.custom_type : event?.event_type?.type}
				</div>
			</div>
			<div className="flex flex-col gap-16 mt-16">
				<div className="flex flex-col gap-16">
					<div className="flex flex-col sm:flex-row gap-16 justify-between">
						<div className="flex flex-col gap-4 flex-1">
							<div style={{ fontSize: 10 }}>When</div>
							<div className="font-bold truncate break" style={{ fontSize: 13 }}>
								{new Date(event?.datetime).toDateString()}
							</div>
						</div>

						<div className="flex flex-col gap-4 flex-1">
							<div style={{ fontSize: 10 }}>Where</div>
							<div className="font-bold flex items-center gap-10" style={{ fontSize: 13, gap: 4 }}>
								{event?.rooms?.slice(0, 2)?.map((room) => (
									<div className="flex " key={room.id}>
										<Avatar className="w-32 h-32 lg:w-40 lg:h-40" src={room?.thumb} />
									</div>
								))}
								<span className="ml-8">{event?.rooms?.length > 2 ? `+${event?.rooms?.length - 2} more` : ''}</span>
							</div>
						</div>
					</div>
					{event?.student ? (
						<div className="flex flex-col gap-4">
							<div style={{ fontSize: 10 }}>Who</div>
							<div className="font-bold" style={{ fontSize: 13 }}>
								{`${event?.student?.first_name} ${event?.student?.last_name}`}
							</div>
						</div>
					) : (
						''
					)}
					{event?.description ? (
						<div className="flex flex-col gap-4">
							<div style={{ fontSize: 10 }}>Description</div>
							<div className="flex font-bold break">{event?.description}</div>
						</div>
					) : null}
				</div>
				<div className="flex justify-center gap-16" style={{ marginTop: '15px' }}>
					<Button
						className="border-red rounded-full border text-red hover:bg-red hover:text-red-50 py-4 flex items-center justify-center gap-10 capitalize md:min-w-128"
						id={`delete-event-${event.id}`}
						onClick={() => DeleteEvent(event)}
						variant="outlined"
					>
						{/* <IconButton size="small"> */}
						<img alt="delete" className="w-25 mr-10 select-none" src="assets/images/dlt.png" />
						{/* </IconButton> */}
						Delete
					</Button>
					<Button
						className="capitalize rounded-full  py-4 border-yellow-edit border text-yellow-edit hover:bg-yellow-edit hover:text-yellow-50 flex items-center justify-center gap-10  select-none min-w-96 md:min-w-128 "
						fontSize="15px"
						id={`update-event-${event.id}`}
						onClick={() => gotoUpdateEvent(event)}
						type="submit"
						variant="outlined"
					>
						<img alt="edit" className="w-25 mr-10 select-none" src="assets/images/circle-edit.png" />
						Edit
					</Button>
				</div>
			</div>
		</div>
	);
};
